module.exports = __webpack_public_path__ + "img/user.3d8aeebe.webp";